// extracted by mini-css-extract-plugin
module.exports = {"userPhoto":"Paginator_userPhoto__3ZLCB","status":"Paginator_status__27RiT","user":"Paginator_user__2Sv-R","usersNav":"Paginator_usersNav__3XAxS","Link":"Paginator_Link__3_t-I"};